import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLTableSize = () => {
  return (
    <div className="html-container">
      <h1>HTML – Table Size</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          HTML tables are used to display data in rows and columns. Controlling the table size ensures proper layout, readability, and responsiveness on different screens.
        </p>
      </section>

      {/* 2. Table Width */}
      <section id="table-width">
        <h2>2. Table Width</h2>
        <p>You can set the table width using the <code>width</code> attribute or CSS:</p>
        <pre>
          <code>{`<!-- Using HTML attribute -->
<table width="500">
  <tr><td>Cell 1</td><td>Cell 2</td></tr>
</table>

<!-- Using CSS -->
<table style="width: 80%;">
  <tr><td>Cell 1</td><td>Cell 2</td></tr>
</table>`}</code>
        </pre>
        <p>Width can be defined in pixels (px) or percentages (%).</p>
      </section>

      {/* 3. Table Height */}
      <section id="table-height">
        <h2>3. Table Height</h2>
        <p>You can also control table height using HTML or CSS:</p>
        <pre>
          <code>{`<!-- Using HTML attribute -->
<table height="200">
  <tr><td>Cell 1</td><td>Cell 2</td></tr>
</table>

<!-- Using CSS -->
<table style="height: 50vh;">
  <tr><td>Cell 1</td><td>Cell 2</td></tr>
</table>`}</code>
        </pre>
        <p>Height can be defined in pixels, percentages, or viewport units.</p>
      </section>

      {/* 4. Column Width */}
      <section id="column-width">
        <h2>4. Column Width</h2>
        <p>Set specific column widths using <code>width</code> in <code>&lt;col&gt;</code> or <code>&lt;td&gt;</code> elements:</p>
        <pre>
          <code>{`<table border="1">
  <col style="width: 150px;">
  <col style="width: 250px;">
  <tr>
    <td>Column 1</td>
    <td>Column 2</td>
  </tr>
</table>`}</code>
        </pre>
      </section>

      {/* 5. Row Height */}
      <section id="row-height">
        <h2>5. Row Height</h2>
        <p>You can set row height using the <code>height</code> attribute or CSS:</p>
        <pre>
          <code>{`<table border="1">
  <tr style="height: 50px;">
    <td>Row 1</td>
    <td>Row 1</td>
  </tr>
  <tr style="height: 100px;">
    <td>Row 2</td>
    <td>Row 2</td>
  </tr>
</table>`}</code>
        </pre>
      </section>

      {/* 6. Responsive Table */}
      <section id="responsive">
        <h2>6. Responsive Table</h2>
        <p>Use CSS to make tables responsive on smaller screens:</p>
        <pre>
          <code>{`<div style="overflow-x: auto;">
  <table style="width: 100%;">
    <tr>
      <td>Cell 1</td>
      <td>Cell 2</td>
      <td>Cell 3</td>
    </tr>
  </table>
</div>`}</code>
        </pre>
      </section>

      {/* 7. Summary */}
      <section id="summary">
        <h2>7. Summary</h2>
        <ul>
          <li>Control table size with <code>width</code> and <code>height</code> attributes or CSS.</li>
          <li>Use pixels, percentages, or viewport units for flexible design.</li>
          <li>Column widths can be defined individually with <code>&lt;col&gt;</code> or <code>&lt;td&gt;</code>.</li>
          <li>Row heights can be set with <code>height</code> CSS property.</li>
          <li>Use overflow and responsive CSS for mobile-friendly tables.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLTableSize;
